import { Trans } from 'react-i18next';

import { ValidationErrorNotification } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../translations';

type TreatmentDaysCountExceededMessageProps = {
   readonly maxValue: number;
   readonly changeToPrescriptionForYear: JSX.Element | undefined;
};

export const TreatmentDaysCountExceededMessage = (props: TreatmentDaysCountExceededMessageProps): JSX.Element => {
   return (
      <ValidationErrorNotification
         testId={'treatmentDaysCountExceeded'}
         label={
            props.changeToPrescriptionForYear ? (
               <Trans
                  i18nKey={prescriptionTranslationKeys.numericalDosage.treatmentDaysCountExceeded}
                  components={{ link: props.changeToPrescriptionForYear }}
                  values={{ maxValue: props.maxValue }}
               />
            ) : (
               <Trans
                  i18nKey={prescriptionTranslationKeys.numericalDosage.treatmentDaysCountExceededWithoutAction}
                  values={{ maxValue: props.maxValue }}
               />
            )
         }
      />
   );
};
